import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";


/// location and business category filter 

// ======================= GET SPONSORSHIP DETAIL =======================
export const fetchSponsorshipDetail = createAsyncThunk(
  "sponsorship/fetchDetail",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/sponsorship/detail", filters);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

// ======================= BOOK SLOT =======================
export const bookSponsorshipSlot = createAsyncThunk(
  "sponsorship/bookSlot",
  async ({ sponsorshipId, week, slotNumber, cardImage = null }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("sponsorshipId", sponsorshipId);
      formData.append("week", week);
      formData.append("slotNumber", slotNumber);

      if (cardImage) {
        formData.append("cardImage", cardImage);
      }

      const res = await api.post("/api/sponsorship/book-slot", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Booking failed");
    }
  }
);

